export default __webpack_public_path__ + "css/return.bundle.css";